import React from 'react'
import { BsChevronLeft } from 'react-icons/bs'
import { HiOutlineCurrencyRupee, HiOutlineDocumentDownload } from 'react-icons/hi'
import { useNavigate } from 'react-router-dom'
import styles from "./Styles/Finance.module.css"

export default function Details() {
  const navigate = useNavigate()
  return (
    <div className={styles.detailsContainer}>
        <div className={styles.detailsHeader}>
        <div className={styles.backIcon}>
            <div onClick={()=>navigate(-1)}>
                <BsChevronLeft size={26} color="#299EFE" />
            </div>
            <p>41542</p>
        </div>

        <div className={styles.content}>
          <div>
            <h3>Total Amount to be earned</h3>
            <h2>₹4,50,000</h2>
          </div>
          <div>
            <h3>Overall Rate</h3>
            <h2>10%</h2>
          </div>
          <div>
            <h3>Total Earned</h3>
            <h2>₹2,00,000</h2>
          </div>
          <div>
            <h3>Remaining</h3>
            <h2>₹2,50,000</h2>
          </div>
        </div>
        </div>

        <div className={styles.headerColumns}>
          <p></p>
          <p>Event</p>
          <p>Paid</p>
          <p>Rate(%)</p>
          <p>Earned</p>
        </div>


      {Array(2).fill('').map(i => {
        return <div className={styles.itemsContainer}>
          
        <h2 className={styles.itemDate}>
          NOV 2022
        </h2>

        <div className={styles.items}>  
          {Array(3).fill('').map(i => {
            return <div className={styles.item}>
            <div className={styles.itemHeader}>
            <div style={{display:'flex',alignItems:'center',gap:16}}>
              <div className={styles.rupeeIcon}>
                <HiOutlineCurrencyRupee color="#F4B920" size={24} />
              </div>
              <div>
                <h2>Nov  21</h2>
                <h3>20:14 PM</h3>
              </div>
              <div className={styles.separator}></div>
              <p>Converted to Project</p>
            </div>
            <div>
              <p><span style={{color:'#BA1CB4'}}>Paid&nbsp;&nbsp;</span>₹15,000.00</p>
            </div>
            <div>
              <p>2%</p>
            </div>
            <div>
              <p><span style={{color:'#299EFE'}}>Pending&nbsp;&nbsp;</span> ₹15,000.00</p>
            </div>
            </div>
            
            <div className={styles.subItem}>
              <h2>Client Transaction Information</h2>

              <div className={styles.subItemList}>
                <div>
                  <h3>Raised On</h3>
                  <p>Nov 23, 2022 | 14:30 PM</p>
                </div>

                <div>
                  <h3>Amount</h3>
                  <p>₹12,000</p>
                </div>

                <div>
                  <h3>Paid On</h3>
                  <p>Nov 23, 2022 | 14:30 PM</p>
                </div>

                <div>
                  <h3>Invoice No.</h3>
                  <p>TXN123</p>
                </div>

                <button style={{width:64,height:64}} className={styles.downloadIcon}>
                    <HiOutlineDocumentDownload color="#299EFE" size={24} />
                </button>
              </div>
            </div>
          </div>
          })}
        </div>
      </div>
      })}

    </div>
  )
}
